import { render, staticRenderFns } from "./JGridItem.vue?vue&type=template&id=7c9f4103&"
import script from "./JGridItem.vue?vue&type=script&lang=ts&"
export * from "./JGridItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports